(() => {
  const product=window.ViuletJourneyProduct,config=window.VIULET_GALLERY_CONFIG;
  if(!product||!config)return;
  // Where this Mirror was designed, kept on its order line (keys starting with _ never show to the customer).
  const designed=()=>({_design_source:'mirror_page',_design_page:window.location.pathname,_design_version:'1'});
  const currency=window.ViuletJourneyCurrency||'USD';
  const options=product.options.map(o=>typeof o==='string'?o:o.name);
  const matches=(variant,s)=>options.every((name,i)=>variant.options[i]===({
    'Frame style':s.presentation.toUpperCase(),
    'Color':s.presentation==='Untethered'?'No Frame':s.finish,
    'Mat Color':['Haloed','Crowned'].includes(s.presentation)?s.mat:'No mat'
  })[name]);
  const find=s=>product.variants.find(v=>matches(v,s));
  const available=s=>Number(s.printInches??s.size)===20&&!!find(s)?.available;
  config.previewPricing=false;
  // A Mirror is built to order. The designer says how long that takes, under its buttons.
  config.deliveryNote=product.variants.some(v=>v.available)?'Built to order in three to five weeks.':'';
  config.normalizeSelection=s=>{
    if(available(s))return s;
    const variant=product.variants.find(v=>v.available&&v.options[0]===s.presentation.toUpperCase());
    if(!variant)return s;
    return {...s,finish:variant.options[1]==='No Frame'?s.finish:variant.options[1],mat:variant.options[2]==='No mat'?s.mat:variant.options[2]};
  };
  config.isChoiceAvailable=(s,field,value)=>{
    if(field==='presentation')return product.variants.some(v=>v.available&&v.options[0]===value.toUpperCase());
    return available({...s,[field]:value});
  };
  config.optionPriceDifference=(s,field,value)=>{
    let rows=product.variants.filter(v=>v.available),chosen;
    if(field==='presentation')chosen=rows.filter(v=>v.options[0]===value.toUpperCase());
    else{
      rows=rows.filter(v=>v.options[0]===s.presentation.toUpperCase());
      if(field==='finish'){
        if(['Haloed','Crowned'].includes(s.presentation))rows=rows.filter(v=>v.options[2]===s.mat);
        chosen=rows.filter(v=>v.options[1]===value);
      }else if(field==='mat'){
        rows=rows.filter(v=>v.options[1]===s.finish);chosen=rows.filter(v=>v.options[2]===value);
      }
    }
    if(!chosen?.length||!rows.length)return null;
    return {amount:(Math.min(...chosen.map(v=>v.price))-Math.min(...rows.map(v=>v.price)))/100,currency};
  };
  config.resolvePrice=async s=>{
    if(Number(s.printInches??s.size)!==20)throw new Error('This edition is available in its original size only.');
    const v=find(s);
    if(!v?.available)throw new Error('This presentation is currently unavailable.');
    return {amount:v.price/100,currency,variantId:v.id,test:false};
  };
  let request;
  config.onClaim=s=>{
    if(request)return request;
    request=(async()=>{
      const quote=await config.resolvePrice(s),root=window.Shopify?.routes?.root||'/';
      const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:quote.variantId,quantity:1,properties:{...designed(),...(window.ViuletUpsell?.mirrorProperties() || {})}}]})});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description||'Your Mirror could not be added. Please try again.');
      window.ViuletUpsell?.completeMirror();
      window.location.assign(root+'cart');
    })().catch(e=>{request=null;throw e;});
    return request;
  };
})();
